<template>
  <div class="add-account-container">
    <button class="gsi-material-button add-account-btn" @click="handleAddAccount">
      <div class="gsi-material-button-state"></div>
      <div class="gsi-material-button-content-wrapper">
        <div class="gsi-material-button-icon">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
            <path fill="none" d="M0 0h48v48H0z"></path>
          </svg>
        </div>
        <span class="gsi-material-button-contents">Add Google account</span>
      </div>
    </button>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { openPopup } from "@/utils/googleAuth";
import { emailAccountsAPI, authAPI } from "@/services/api";
import { showToast } from "@/utils/toast";

export default defineComponent({
  name: "GoogleAddEmailAccount",
  emits: ['accountAdded'],
  
  methods: {
    async handleAddAccount() {
      try {
        // Open popup with simple scopes (false = minimal scopes)
        const { popup, authCode } = await openPopup(false, "");
        
        if (authCode) {
          // Call the new email-accounts endpoint with the oauth code
          const addAccountResponse = await emailAccountsAPI.addAccount(authCode);
          
          // Close the first popup
 
          
          // Get the email address of the newly added account
          const newAccountEmail = addAccountResponse.data.address;
          const isNew = addAccountResponse.data.is_new;
          
          if(!isNew) {
            popup.close();
            return;
          }
            // Immediately open second popup with advanced scopes for sync
          const { popup: syncPopup, authCode: syncAuthCode } = await openPopup(true, newAccountEmail);
          
          if (syncAuthCode) {
            // Sync the newly added account
            await authAPI.sync(syncAuthCode);
            syncPopup.close();
          } else {
            // User cancelled sync popup, but account was still added
            showToast("Warning", `Account ${newAccountEmail} added but not synced. You can sync it manually from the account page.`);
          }
          
          // Emit event to parent component to refresh data
          this.$emit('accountAdded');
        } else {
          // User closed popup without completing auth
          console.log("User cancelled the authentication process");
        }
        
        popup.close();
      } catch (error) {
        console.error("Error adding Google account:", error);
        showToast("Error", error.response.data.details.message);
      } 
    }
  }
});
</script>

<style scoped>
.add-account-container {
  display: flex;
  justify-content: flex-start;
  margin-top: 1rem;
  margin-left: 0;
  padding-left: 0;
}

.add-account-btn {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -webkit-appearance: none;
  background-color: #f8f9fa;
  background-image: none;
  border: none;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #1f1f1f;
  cursor: pointer;
  font-size: 14px;
  height: 40px;
  letter-spacing: 0.25px;
  outline: none;
  overflow: hidden;
  padding: 0 12px;
  position: relative;
  text-align: center;
  -webkit-transition: background-color .218s, color .218s;
  transition: background-color .218s, color .218s;
  vertical-align: middle;
  white-space: nowrap;
  width: auto;
  max-width: 400px;
  min-width: min-content;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.add-account-btn .gsi-material-button-icon {
  height: 20px;
  margin-right: 12px;
  min-width: 20px;
  width: 20px;
}

.add-account-btn .gsi-material-button-content-wrapper {
  -webkit-align-items: center;
  align-items: center;
  display: flex;
  -webkit-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  flex-wrap: nowrap;
  height: 100%;
  justify-content: space-between;
  position: relative;
  width: 100%;
}

.add-account-btn .gsi-material-button-contents {
  -webkit-flex-grow: 1;
  flex-grow: 1;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
}

.add-account-btn .gsi-material-button-state {
  -webkit-transition: opacity .218s;
  transition: opacity .218s;
  bottom: 0;
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.add-account-btn:disabled {
  cursor: default;
  background-color: #f8f9fa;
}

.add-account-btn:disabled .gsi-material-button-contents {
  opacity: 38%;
}

.add-account-btn:disabled .gsi-material-button-icon {
  opacity: 38%;
}

.add-account-btn:not(:disabled):active .gsi-material-button-state,
.add-account-btn:not(:disabled):focus .gsi-material-button-state {
  background-color: #303030;
  opacity: 12%;
}

.add-account-btn:not(:disabled):hover {
  background-color: #f5f5f5;
}

.add-account-btn:not(:disabled):hover .gsi-material-button-state {
  background-color: #303030;
  opacity: 4%;
}

/* Mobile responsive styles */
@media (max-width: 768px) {
  .add-account-container {
    justify-content: center;
    margin-top: 0.75rem;
  }
  
  .add-account-btn {
    font-size: 13px;
    height: 36px;
    padding: 0 10px;
    max-width: 200px;
  }
  
  .add-account-btn .gsi-material-button-icon {
    height: 18px;
    margin-right: 8px;
    min-width: 18px;
    width: 18px;
  }
  
  .add-account-btn .gsi-material-button-contents {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .add-account-btn {
    font-size: 12px;
    height: 34px;
    padding: 0 8px;
    max-width: 180px;
  }
  
  .add-account-btn .gsi-material-button-icon {
    height: 16px;
    margin-right: 6px;
    min-width: 16px;
    width: 16px;
  }
  
  .add-account-btn .gsi-material-button-contents {
    font-size: 12px;
  }
}
</style> 